<template>
	<div class="tab-pane">
		<slot></slot>
	</div>
</template>

<script setup>
import { inject, onMounted } from '@vue/runtime-core'

const props = defineProps({
	active: {
		type: Boolean,
		default: false
	},
	path: {
		type: Array,
		default: () => []
	},
	name: {
		type: String
	},
	muted: {
		type: Boolean,
		default: false
	}
})

const amplitude = inject('amplitude')

onMounted(() => {
	if (!props.muted) {
		amplitude.logEvent('BlockView', {
			title: props.name + 'DetailsBlock',
			path: props.path
		})
	}
})
</script>

<style scoped lang="scss">
.tab-pane {
	margin-top: 1.4rem;
}
</style>
